import axios from '../../axios'
import config from '../../config'
import ApiRequest from '../request'

export default class Massmails {
  constructor() {
    this.apiRequest = new ApiRequest()
  }

  async postMail(params) {
    return await axios({
      method: 'post',
      url: `${config.BASE_URL_V2}/backoffice/emails`,
      headers: {
        auth_token: config.auth_token,
      },
      data: params,
    })
  }
}
